import { DATE_FORMAT, DATE_TIME_FORMAT } from '@nile/components';
import dayjs from 'dayjs';
import { get, isEmpty } from 'lodash';

const changeTimeFormat = (value, unit = 'hours') => {
  let valueInHours = value;
  if (unit.toLocaleLowerCase() === 'days') {
    valueInHours *= 24;
  }
  const days = Math.floor(valueInHours / 24);
  const Remainder = valueInHours % 24;
  const hours = Math.floor(Remainder);
  const minutes = Math.floor(60 * (Remainder - hours));
  return { days, hours, minutes };
};

const getLabelText = (name) => {
  switch (name) {
    case 'recurringContractRevenue':
      return 'msp.reports.profitablity.overall.from.recurring';
    case 'nonContractRevenue':
      return 'msp.reports.profitablity.overall.from.others';
    case 'totalRevneue':
      return 'reports.charts.total_tickets_count.name';
    default:
      return name;
  }
};

const getPercentageValue = (num, denum) => {
  if (Number(num)) {
    return Number((Number(num) / Number(denum)) * 100).toFixed(2);
  }
  return 0;
};

const formatDate = (dt, time, endTime = false) => {
  if (time) {
    if (endTime) {
      return dayjs(dt)
        .endOf('day')
        .format(DATE_TIME_FORMAT);
    }
    return dayjs(dt).format(DATE_TIME_FORMAT);
  }
  return dayjs(dt).format(DATE_FORMAT);
};

const getYearDate = (key) => {
  if (key === 'lastYear') {
    const startDateLastYear = dayjs()
      .subtract(1, 'year')
      .startOf('year');
    const endDateLastYear = dayjs()
      .subtract(1, 'year')
      .endOf('year');
    return [
      formatDate(startDateLastYear, true, false),
      formatDate(endDateLastYear, true, true)
    ];
  }
  if (key === 'thisYear') {
    const startDate = dayjs().startOf('year');
    const endDate = dayjs().endOf('year');
    return [
      formatDate(startDate, true, false),
      formatDate(endDate, true, true)
    ];
  }
  return key;
};
const getCellValue = (dataObj, key) => {
  if (isEmpty(dataObj)) {
    return '';
  }
  return get(dataObj, key);
};

export {
  changeTimeFormat,
  getCellValue,
  getLabelText,
  getPercentageValue,
  getYearDate
};
